import { Fragment } from "@wordpress/element";
import { PanelBody, SelectControl } from '@wordpress/components';
import { InspectorControls, InnerBlocks, MediaUpload, RichText } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

const ImageText = {
  title: __('Image and text'),
  description: __('Image and text block for the ABS theme'),
  icon: 'id-alt',
  attributes: {
    imagePosition: {
      default: 'left',
      type: 'string',
    },
    imgUrl: {
      type: 'string',
      default: 'https://dummyimage.com/480x480/cadae2/49585f.png&text=Placeholder',
    },
    imgAlt: {
      type: 'string',
    },
    attribution: {
      type: 'string'
    }
  },
  supports: {
    customClassName: false,
  },
  edit({ className, attributes, setAttributes, isSelected }) {
    const { imagePosition, imgUrl, imgAlt, attribution } = attributes;

    const allowedBlocks = [ 'core/image', 'core/heading', 'core/paragraph', 'core/list', 'core/button', 'core/spacer' ];
    const contentTemplate = [
      [ 'core/heading', { placeholder: __('Title') } ],
      [ 'core/paragraph', { placeholder: __('Content') } ],
    ];

    function onImagePositionChange( position ) {
      setAttributes( { imagePosition: position } );
    }

    function selectImage(value) {
      setAttributes({
        imgUrl: value.media_details.sizes.large.source_url,
        imgAlt: value.alt_text,
      })
    }

    return (
      <Fragment>
        <div className={className}>
          <div className="container">
            <div className="row">
              <div className="col">
                { imagePosition === 'left'
                  ?
                  <div className="row">
                    <div className="col-sm-4">
                      <MediaUpload
                        onSelect={selectImage}
                        render={ ({open}) => {
                          return <img
                            src={attributes.imgUrl}
                            className={"img-fluid"}
                            onClick={open}
                          />;
                        }}
                      />
                      <div className={"attribution"}>
                        <RichText
                          tagName="p"
                          value={ attribution }
                          placeholder={ __('Insert attribution information') }
                          allowedFormats={['core/link']}
                          onChange={nextAttribution => setAttributes({ attribution: nextAttribution })}
                        />
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <InnerBlocks
                        template={contentTemplate}
                        allowedBlocks={allowedBlocks}
                      />
                    </div>
                  </div>
                  :
                  <div className="row">
                    <div className="col-sm-4 order-sm-2">
                      <MediaUpload
                        onSelect={selectImage}
                        render={ ({open}) => {
                          return <img
                            src={attributes.imgUrl}
                            className={"img-fluid"}
                            onClick={open}
                          />;
                        }}
                      />
                      <div className={"attribution"}>
                        <RichText
                          tagName="p"
                          value={ attribution }
                          placeholder={ __('Insert attribution information') }
                          allowedFormats={['core/link']}
                          onChange={nextAttribution => setAttributes({ attribution: nextAttribution })}
                        />
                      </div>
                    </div>
                    <div className="col-sm-8 order-sm-1">
                      <InnerBlocks
                        template={contentTemplate}
                        allowedBlocks={allowedBlocks}
                      />
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        { isSelected &&

        <InspectorControls>
          <PanelBody title={ __('Block Style') }>
            <SelectControl
              label="Image position"
              value={ imagePosition }
              options={
                [
                  { value: 'left', label: 'Left' },
                  { value: 'right', label: 'Right' },
                ]
              }
              onChange={ onImagePositionChange }
            />
          </PanelBody>
        </InspectorControls>
        }
      </Fragment>
    );
  },

  save({ className, attributes }) {
    const { imagePosition, imgUrl, imgAlt, attribution } = attributes;

    return (
      <div className={ className }>
        <div className="container">
          <div className="row">
            <div className="col">
              {imagePosition === 'left'
                ?
                <div className={"row"}>
                  <div className={"col-sm-4"}>
                    <img src={imgUrl} className={"img-fluid"} alt={ imgAlt } />
                    {attribution && (
                        <div className={"attribution"}>
                          <RichText.Content tagName="p" value={ attribution } />
                        </div>
                    )}
                  </div>
                  <div className={"col-sm-8"}>
                    <InnerBlocks.Content />
                  </div>
                </div>
                :
                <div className={"row"}>
                  <div className={"col-sm-4 order-sm-2"}>
                    <img src={imgUrl} className={"img-fluid"} alt={ imgAlt } />
                    {attribution && (
                      <div className={"attribution"}>
                        <RichText.Content tagName="p" value={ attribution } />
                      </div>
                    )}
                  </div>
                  <div className={"col-sm-8 order-sm-1"}>
                    <InnerBlocks.Content />
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  },
};

export default ImageText;
